<agr-page-toolbar [pageTitle]="pageTitle()">
  <div class="page">
    <div class="page-header">
      <span class="text-color--primary-500 title">{{ 'blightV2.advice.title' | translate }}</span>
      <app-crop-year-selector [readOnly]="true" />
    </div>
    <div class="flex flex--row full-width">
      <mat-tab-group [selectedIndex]="selectedTabIndex()" (selectedTabChange)="onTabChange($event)">
        <mat-tab [label]="'blightV2.advice.overview.title' | translate" />
        <mat-tab [label]="'blightV2.advice.insights.title' | translate" />
      </mat-tab-group>
    </div>
    @if (selectedTabIndex() === 0) {
      <ng-container *ngTemplateOutlet="adviceOverview" />
    } @else if (selectedTabIndex() === 1) {
      <ng-container *ngTemplateOutlet="insight" />
    }
  </div>
</agr-page-toolbar>

<ng-template matTabContent #adviceOverview>
  <app-blight-advice-overview (adviceClick)="onCropFieldClick($event)" />
</ng-template>

<ng-template matTabContent #insight>
  <app-blight-insight-page style="width: 100%"></app-blight-insight-page>
</ng-template>
